/**
 * THE MARK AND THE WORDMARK, shared by the two screens a person meets
 * before they are anybody: the front door and sign-in.
 *
 * Shared because they are the SAME moment from the visitor's side --
 * arrive, say who you are, get in -- and the seam between them being
 * visible was the bug: the apex was a branded card and sign-in was a
 * navy glass panel with an h1.
 *
 * The MARK, not public/brand/polywog-lockup.jpg: that is a JPEG on
 * black and carries its own background into a light page. favicon.svg
 * is transparent and already the favicon, so the wordmark is text
 * beside it and the whole assembly themes and scales.
 */
import { Stack, Title } from '../../../strata';

export function Brand() {
  return (
    <Stack direction="column" gap="md" align="center">
      <img src="/favicon.svg" alt="" width={108} height={108} />
      <Title level={1} tone="brand">
        polywog
      </Title>
    </Stack>
  );
}
